import { createSlice } from '@reduxjs/toolkit';

import { fetchChatsRegister } from './thunks';
import { InitialState } from './types';

const initialState: InitialState = {
  loading: false,
  error: '',
};

export const slice = createSlice({
  name: 'register',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatsRegister.pending, (state) => {
        state.error = '';
        state.loading = true;
      })
      .addCase(fetchChatsRegister.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchChatsRegister.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});
